__webpack_require__.p = "https://assets.cdn.garenanow.com/assets/wheel.ff.garena.com/";